module.exports = __webpack_public_path__ + "8c6c734b3d311c502fb20f181e529fb5.MP3";